module.exports = __webpack_public_path__ + "static/media/polygon-dark.3ad66459.svg";